import { state } from "./state";

export default {
  getLoading() {
    return state.loading;
  },
  getProducts() {
    return state.products;
  },

  getTotalPages() {
    return state.totalPage;
  },

  getTotal() {
    return state.totalItems;
  },

  getProduct() {
    return state.product;
  },

  getOperators() {
    return state.operators;
  },

  getOperator() {
    return state.operator;
  },

  getActiveOperatorId() {
    return state.activeOperatorId;
  },

  // getActiveOperatorCode() {
  //   const res = state.operators.find((operator, index) => index === state.activeOperatorId);
  //   return res.code;
  // },

  getAllMObileNetworks() {
    return state.allMobileNetworks;
  },

  getAllVendors() {
    return state.allVendors;
  },

  getNetworkName() {
    return state.networkName;
  },
};
